<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        title="选择付款方式"
        class="customer-edit"
        width="80%"
        top="5vh">
      <el-button type="primary" style="margin-bottom: 3%" @click="onCheckedSelect">添加</el-button>
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="payManners"
          @select="selectTest"
          @select-all="selectAll">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="付款方式">
              <el-input v-model.trim="filter.payNodeName" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" align="center" width="55"/>
        <el-table-column prop="payNodeType" align="center" label="付款方式"/>
        <el-table-column label="操作" align="center" width="120px">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </vm-table>
    </el-dialog>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "PayMannerSelect",
    components: { VmTable, VmSearch},
    data() {
      return {
        idList: "",
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        filter: {
          pmid: "",
          payNodeName: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
      onCheckedSelect() {
        this.$emit("select", this.idList);
        this.dialogVisible = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
